export default __webpack_public_path__ + "static/media/html5.23784160.png";